import { render } from "./Causacion.vue?vue&type=template&id=34d2f0ff"
import script from "./Causacion.vue?vue&type=script&lang=js"
export * from "./Causacion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__